import React from 'react';
import ReactDOM from 'react-dom';
import App from './App.js';
import MockData from './PersonAfternoonList.js';
import MockData2 from './PersonMorningList.js';

ReactDOM.render(<App morningData={MockData} afternoonData={MockData2}/>, document.getElementById('root'));